<script type="text/javascript">
	import Tab,{ Label as TabLabel } from '@smui/tab';
	import TabBar from '@smui/tab-bar';
	import Textfield from "@smui/textfield";
	import { writable } from "svelte/store";
	import LoadState from "../../Enums/LoadState";
	import ModalWindow from "../../UI/ModalWindow.svelte";
	import PortDataSwitch from "./PortDataSwitch.svelte";
	import "./Ports.scss";
	import PortsTable from "./PortsTable.svelte";
	import PortWindow from "./PortWindow.svelte";
	import PortsStore from "./Store";
	

	let loadState = PortsStore.meta.loadState;
	let loaded = false;
	$: {
		loaded = $loadState === LoadState.LOADED;
	}

	let visible = PortsStore.meta.visible;
	PortsStore.meta.visible.subscribe((visible) => {
		if (visible
			// User.hasFeature(Feature.HURRICANES.VIEW)
			) {
			PortsStore.actions.init();
		}
	});

	let ports = PortsStore.results.ports;
	let openPorts = PortsStore.results.portsOpen;
	let lastUpdated = PortsStore.meta.lastUpdated;
	$: {
		$visible;
		$lastUpdated;
		PortsStore.actions.updateFeatureCollection();
		PortsStore.actions.updateVisibility();
	}

	$: {
		$lastUpdated;
		$ports = $ports;
	}

	let rawFilterString = PortsStore.filters.filterString;

	let hstyle = "font-weight:bold;margin-top:5px;margin-bottom:5px;";

	let applyPaste = (inputValue) => {
		// TODO:
	};
	let onFilterInput = (e) => {
		if (e.inputType === "insertFromPaste") {
			applyPaste(e.target.value);
		} else if (e.inputType === "insertText") {
			applyPaste(e.target.value);
		}
	};
	let onFilterKeyUp = (e) => {
		if (e.key === "Enter") {
			applyPaste(e.target.value);
		}
	};

	let tabs = ["List"];
	let activeTab = writable("List");

	let portToggleList = PortsStore.toggleList;

</script>

{#if loaded}
	<ModalWindow
		title={`Ports`}
		hasCloseButton={true}
		hasBackground={false}
		resizable={true}
		draggable={true}
		fullscreen={false}
		padding={false}
		position="top-right"
		height="70%"
		bind:open={$visible} >

		<TabBar tabs={tabs} let:tab bind:active={$activeTab} class="border-shadow">
			<Tab tab={tab} minWidth><TabLabel>{tab}</TabLabel></Tab>
		</TabBar>

		
		{#if $activeTab === "List"}
		
			<div class="content" style="height:auto;">

				<div class='padding border-shadow'>
					{#each portToggleList as portListData, i}
						<PortDataSwitch data={portListData} />
					{/each}				
				</div>
				<div class="padding">

					<Textfield fullwidth dense variant="filled" label="Filter ports by name..."
						bind:value={$rawFilterString}
						on:input={onFilterInput}
						on:keyup={onFilterKeyUp} />

					<PortsTable
						ports={$ports}
						filterString={$rawFilterString}
						on:update={()=>{ $lastUpdated = Date.now(); }}
						/>

				</div>
			</div>
		{/if}

	</ModalWindow>

	{#each $openPorts as openPort, index (openPort.port.uniqId)}
		<ModalWindow
			title={openPort.port.name}
			hasCloseButton={true}
			hasBackground={false}
			resizable={true}
			draggable={true}
			fullscreen={false}
			padding={false}
			position="top-right"
			height="65%"
			open={true} 
			on:close={()=>{
				PortsStore.actions.closePort(openPort.port);
			}}>
			<PortWindow portData={openPort}/>
		</ModalWindow>
	{/each}
{/if}
